import './header.styles.scss';

const Header = () => {
  return (
    <div id='home' className='main-image'>
      <div className='header-container'>
        <div className='above-header' />
        <div className='main-image-title'>Carpenko</div>
        <div className='main-image-small-title'>
          Вишукане поєднання світових технологій <br /> та справжньої
          української майстерності
        </div>
      </div>
    </div>
  );
};

export default Header;
